import { usePlaylist } from 'Playlists';
import { useContentProgress } from 'ContentProgress';
import { useCurrentUser } from 'FrontRoyalAngular';
import { useCallback, useMemo } from 'react';
import { useLaunchableStreams } from 'Streams';
import { getActivePlaylistLocalePackId } from 'Users';
import { type StreamForDashboard } from 'Lessons';

export const useNextUpStream = () => {
    const currentUser = useCurrentUser();
    const { streamProgressByLocalePackId } = useContentProgress();

    const activePlaylistLocalePackId = getActivePlaylistLocalePackId(currentUser);
    const activePlaylist = usePlaylist(activePlaylistLocalePackId ?? '');
    const playlistStreamLocalePackIds = useMemo(
        () => activePlaylist?.streamEntries.map(entry => entry.localePackId) ?? [],
        [activePlaylist],
    );
    const playlistStreams = useLaunchableStreams(playlistStreamLocalePackIds);

    const bookmarkedStreamLocalePackIds = useMemo(
        () => currentUser?.favoriteLessonStreamLocalePacks?.map(lp => lp.id) ?? [],
        [currentUser],
    );
    const bookmarkedStreams = useLaunchableStreams(bookmarkedStreamLocalePackIds);

    const isIncompleteStream = useCallback(
        (s: StreamForDashboard) => !streamProgressByLocalePackId[s.localePackId]?.complete,
        [streamProgressByLocalePackId],
    );

    const nextStreamInPlaylist = playlistStreams.find(isIncompleteStream);
    const nextStreamInBookmarkedStreams = bookmarkedStreams.find(isIncompleteStream);

    return {
        nextStreamInPlaylist,
        nextStreamInBookmarkedStreams,
        nextUpStream: nextStreamInPlaylist ?? nextStreamInBookmarkedStreams,
    };
};
